import React, { createContext } from "react";
import useModal from "../hooks/useModal";
import Modal from "../components/modal/Modal";

const ModalContext = createContext();

let ModalProvider = ({ children }) => {
  let { modal, handleModal, modalContent, modalBottomReached, setModalBottomReached } =
    useModal();

  return (
    <ModalContext.Provider
      value={{
        modal,
        handleModal,
        modalContent,
        modalBottomReached,
        setModalBottomReached,
      }}
    >
      <Modal />
      {children}
    </ModalContext.Provider>
  );
};

export { ModalContext, ModalProvider };
